import { IVendorActions, VendorContext } from './actions.types';
import { IVendorData } from '@/models';

export const actions: IVendorActions = {
  fetchVendors(context: VendorContext): Promise<void> {
    return this.$services.vendor
      .fetchVendors()
      .then((vendors: IVendorData[]) => {
        context.commit('SET_VENDORS', vendors);
      });
  },

  fetchVendor(context: VendorContext, payload: string): Promise<void> {
    return this.$services.vendor
      .fetchVendor(payload)
      .then((vendor: IVendorData) => {
        const index = context.state.vendors.findIndex(
          (v: IVendorData) => v.id === vendor.id
        );
        if (index === -1) {
          context.commit('ADD_VENDOR', vendor);
        } else {
          context.commit('UPDATE_VENDOR', vendor);
        }
      });
  },

  createVendor(context: VendorContext, payload: IVendorData): Promise<void> {
    return this.$services.vendor
      .createVendor(payload)
      .then((vendor: IVendorData) => context.commit('ADD_VENDOR', vendor));
  },

  updateVendor(context: VendorContext, payload: IVendorData): Promise<void> {
    return this.$services.vendor
      .updateVendor(payload)
      .then((vendor: IVendorData) => {
        const index = context.state.vendors.findIndex(
          (v: IVendorData) => v.id === vendor.id
        );
        if (index === -1) {
          context.commit('ADD_VENDOR', vendor);
        } else {
          context.commit('UPDATE_VENDOR', vendor);
        }
      });
  },

  deleteVendor(context: VendorContext, payload: string): Promise<void> {
    return this.$services.vendor.deleteVendor(payload).then(() => {
      context.commit('REMOVE_VENDOR', payload);
    });
  },

  uploadVendorFile(_: VendorContext, payload: File): Promise<void> {
    return this.$services.vendor.uploadVendorFile(payload).then(() => {
      // No data to return since the data is not a type of vendor
    });
  }
};
